import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { MktButton, UseHeader, VerifyCodeInput } from '@cps'
import { toast, useHistoryNew } from '@utils'
import MktController from 'controllers/mktController'
import { memberMobx } from '@mobxStore'
import i18n from 'i18next'
import MemberApi from '@api/member.api'
import './index.scss'

// interface
interface IProps extends IPage, RouteComponentProps {
}
const verifyCodeType = memberMobx.verifyCodeTypes.login

const Login: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const {
    type,
    account,
    countryCode
  } = match.params as any
  const [verifyCodeInfo, setVerifyCodeInfo] = useState<any>({})
  // Data Method

  // Component Event
  const goBack = () => {
    history.goBack()
  }
  const handleLogin = () => {
    const params: any = {}
    if (!verifyCodeInfo.inputValue) {
      toast({ message: i18n.t('mkt.common.tipCode') })
      return
    }
    if (type === 'email') {
      params.email = account
    } else {
      params.mobile = account
      params.countryCode = countryCode
    }
    params.captcha = verifyCodeInfo.inputValue
    memberMobx.login('normal', params).then((success: any) => {
      if (agreementJudge && !success?.agreeTime && success?.memberId) {
        MemberApi.agreeClause({
          memberId: success?.memberId
        }).then(() => {
          memberMobx.refreshMemeberBenefits()
        })
      }
      if (success) {
        toast({ message: i18n.t('mkt.common.loginSuccess') })
        goBack()
      }
    })
  }
  useIonViewWillEnter(() => {
    setVerifyCodeInfo({})
  })
  const agreementJudge = boJudge.checkKey('agreement') // bo控制隐私协议模块
  return (
    <IonPage className='verify-page'>
      <UseHeader onBack={goBack} title={i18n.t('mkt.common.tipCode')}></UseHeader>
      <IonContent className='page-content'>
        <div className='panel'>
          <div className='des'>
            {i18n.t('mkt.member.isSendCode', { name: type === 'email' ? account : `+${countryCode} ${account}` })}
          </div>
          <VerifyCodeInput autoSend codeType={verifyCodeType} account={account} accountType={type} countryCode={countryCode} onChange={(val: any) => setVerifyCodeInfo(val)} />
          <div className='footer'>
            <MktButton text={i18n.t('common.loginIn')} disabled={!verifyCodeInfo.valid} onClick={handleLogin} />
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(Login)
